// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"091312b8","453":"4297e0f3","474":"f4a32a81","699":"bb1fc285"}[chunkId] + ".chunk.js";
};